import React, { useEffect, useState } from "react";
import { Button, IconButton, TextField } from "@mui/material";
import { XMarkIcon } from "shared/icons/XMarkIcon";

export const SurveyOptionsField = (props: SurveyOptionsFieldProps) => {
  const { options, onChange, onBeforeChange } = props;
  const [isNewFieldAdded, setIsNewFieldAdded] = useState<boolean>(!options.length);

  const handleOptionChange = (index: number, option: string) => {
    const temp = [...options];
    temp[index] = onBeforeChange ? onBeforeChange(option) : option;
    onChange(temp);

    if (index === options.length - 1 && option) {
      setIsNewFieldAdded(false);
    }
  };

  const handleRemoveOption = (index: number) => {
    const temp = [...options];
    temp.splice(index, 1);
    onChange(temp);
  };

  useEffect(() => {
    setIsNewFieldAdded(!options.length);
  }, [options]);

  return (
    <div className="layout-survey-options-field">
      {(isNewFieldAdded ? [...options, ""] : options).map((option, index) => {
        return (
          <SurveyOption
            key={index}
            value={option}
            onChange={(value) => handleOptionChange(index, value)}
            onRemove={() => handleRemoveOption(index)}
          />
        );
      })}
      <Button onClick={() => setIsNewFieldAdded(true)} variant="text" size="small" disabled={isNewFieldAdded}>
        + Add Option
      </Button>
    </div>
  );
};

const SurveyOption = (props: SurveyOptionProps) => {
  const { value, onChange, onRemove } = props;

  return (
    <div className="module-survey-option-field">
      <TextField value={value} onChange={(e) => onChange(e.target.value)} />
      <div className="module-survey-option-field-actions">
        <IconButton onClick={onRemove} size="small">
          <XMarkIcon />
        </IconButton>
      </div>
    </div>
  );
};

interface SurveyOptionsFieldProps {
  options: string[];
  onChange: (value: string[]) => void;
  onBeforeChange?: (option: string) => string;
}

interface SurveyOptionProps {
  value: string;
  onChange: (value: string) => void;
  onRemove?: () => void;
}
